import React from 'react';
import Typography from '@mui/material/Typography';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineContent from '@mui/lab/TimelineContent';

const StoryLine = ({alignFrom, oppositeContent, contentTitle, content, icon}) => {
    return (
        <TimelineItem>
            <TimelineOppositeContent
                sx={{m: 'auto 0'}}
                align={alignFrom}
                variant="body2"
                color="text.secondary"
            >
                {/*{oppositeContent}*/}
                <Typography
                    variant="h6"
                    sx={{fontWeight: 600, color: "#1e68d8", textShadow: "2px 1px 1px lightblue"}}
                >
                    {contentTitle}
                </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineConnector/>
                <TimelineDot variant="filled" color="primary">
                    {icon}
                </TimelineDot>
                <TimelineConnector/>
            </TimelineSeparator>
            <TimelineContent sx={{py: '12px', px: 2}}>
                {/*<Typography variant="h6" component="span">*/}
                {/*    {contentTitle}*/}
                {/*</Typography>*/}
                <Typography sx={{textAlign: "justify", color: "#668"}}>
                    {content}
                </Typography>
            </TimelineContent>
        </TimelineItem>
    );
};

export default StoryLine;
